import $ from 'jquery';
import {shuffleArray} from "../playUtil.es6";
import PlayAudio from "../memo/playAudio.es6";

require('jsrender')($);

const SET_TMPL = $.templates(`
<div class="pack-test-set">
    <div class="pack-test-set__title">{{>~l18n.get('packTest.qsMatching')}}</div>
    <div class="row pack-test-set__matching">
        <div class="col-md-6 pack-test-set__matching-questions">
            <ul>
            {{for questions}}
                <li class="pack-test-set__matching-question" data-card="{{:id}}">
                    <div class="row no-gutters">
                        <div class="col-auto">
                            <select class="form-control w-auto d-inline-block mr-3">{{:~root.answerSelect}}</select>
                        </div>
                        {{if audio}}
                        <div class="col-auto mr-3 pack-test-set__matching_question_audio">
                            <audio src="{{attr:audio}}"></audio>
                            <a class="btn btn-light" data-handler="playAudio"><span class="fal fa-volume"></span></a>
                        </div>
                        {{/if}}
                        {{if image}}<div class="mr-3 col pack-test-set__matching-question-image"><img src="{{attr:image}}"/></div>{{/if}}                    
                        <div class="col pack-test-set__matching-question-text fl-tt-{{:textType}}">{{if textType == 'html'}}{{:text}}{{else}}{{> text}}{{/if}}</div>
                    </div>
                </li>
            {{/for}}
            </ul>
        </div>
        <div class="col-md-6 pack-test-set__matching-answers">
            <ul>
            {{for answers}}
                <li class="row no-gutters pack-test-set__matching-answer" data-id="{{:id}}">
                    <div class="col-auto">
                        <span class="form-control w-auto d-inline-block mr-3 pack-test-set__matching-answer-letter">{{>letter}}</span>
                    </div>
                    {{if audio}}
                    <div class="col-auto mr-3 pack-test-set__matching_answer_audio">
                        <audio src="{{attr:audio}}"></audio>
                        <a class="btn btn-light" data-handler="playAudio"><span class="fal fa-volume"></span></a>
                    </div>
                    {{/if}}
                    {{if image}}<div class="col mr-3 pack-test-set__matching-answer-image"><img src="{{attr:image}}"/></div>{{/if}}                    
                    <div class="col pack-test-set__matching-answer-text  fl-tt-{{:textType}}">{{if textType == 'html'}}{{:text}}{{else}}{{> text}}{{/if}}</div>                    
                </li>
            {{/for}}
            </ul>
        </div>
    </div>
</div>`);

const SELECT_TMPL = $.templates(`
<option></option>
{{for answers}}<option value="{{:id}}">{{>letter}}</option>{{/for}}
`);

const ANSWER_TMPL = $.templates(`
<span class="pack-test-set__matching-question-expected fl-keep-nl">{{>~l18n.get('packTest.qsMatching.expected')}} {{>expected}}.</span>        
`);

const LETTER_ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

function getLetterByN(n) {
    n = Math.floor(Math.abs(n));

    let out = '';
    while (true) {
        if (n < LETTER_ALPHABET.length) {
            out = LETTER_ALPHABET.charAt(n) + out;
            break;
        } else {
            const rem = n % LETTER_ALPHABET.length;
            n = (n - rem) / LETTER_ALPHABET.length - 1;
            out = LETTER_ALPHABET.charAt(rem) + out;
        }
    }

    return out;
}

export default class TestMatching {
    constructor(params) {
        this.testList = params.testList;
        this.sideAdapter = params.sideAdapter;
        this.l18n = params.l18n;
        this.checkers = params.checkers;
        this.test = params.test;
    }

    create(tasks) {
        const sides = this.sideAdapter;

        const answers = tasks.map(item => {
            const preset = sides.answer(item);
            return {id: item.id, ...preset};
        });
        shuffleArray(answers);
        answers.forEach((item, index) => {
            item.letter = getLetterByN(index);
        });

        const questions = tasks.map(item => {
            const preset = sides.question(item);
            return {id: item.id, ...preset};
        });
        shuffleArray(questions);

        const expected = {};
        answers.forEach((item) => {
            expected[item.id] = item.letter;
        });

        questions.forEach(q => {
            this.checkers.push(() => {
                const view = this.testList.find(`.pack-test-set__matching-question[data-card=${q.id}]`);
                const select = view.find('select').prop('disabled', true);
                const userAnswer = select.val();
                if (parseInt(userAnswer) === q.id) {
                    view.addClass('pack-test-set__matching-question--correct');
                    this.test.correctAnswers += 1;
                } else {
                    view.addClass('pack-test-set__matching-question--wrong');
                    view.prepend(ANSWER_TMPL.render({expected: expected[q.id]}, this));
                    this.testList.find(`.pack-test-set__matching-answer[data-id=${q.id}]`).removeClass('pack-test-set__matching-answer--occupied');
                }
            });
        });

        const model = {
            questions: questions,
            answers: answers,
            answerSelect: SELECT_TMPL.render({answers: answers})
        };

        const html = $(SET_TMPL.render(model, this));

        const selects = html.find('.pack-test-set__matching-questions').find('select');
        const answerViews = html.find('.pack-test-set__matching-answer[data-id]');
        selects.change(() => {
            const selectedValues = {};
            selects.each((index, select) => selectedValues[select.value] = true);
            delete selectedValues[''];
            answerViews.each((index, view) => {
                view = $(view);
                view.toggleClass('pack-test-set__matching-answer--occupied', view.data('id') in selectedValues);
            })
        });

        html.find('a[data-handler=playAudio]').each(function (e) {
            const anchor = $(this);
            PlayAudio.initSingleSide(anchor, false, anchor.closest('div'));
        });

        this.testList.append(html);
    }
}